import { useState, useEffect } from "react";
import SubstitutionIcon from '../images/icons/substitution.png';
import AvatarIcon from '../images/icons/avatar.svg';

export default function TeamSubstitutions ({ playersData, matchId }) {

    // PlayerId -> Player (for both teams)
    const getPlayersByIds = () => {
        const playersByIds = {};
        playersData.eventParticipants[0]?.lineup?.players?.forEach(player => {
            playersByIds[player.id] = player;
        });
        playersData.eventParticipants[1]?.lineup?.players?.forEach(player => {
            playersByIds[player.id] = player;
        });
        return playersByIds;
    };

    const playersByIds = getPlayersByIds();

    const getSubstitutions = (teamNumber) => {
        const substitutions = [];
        playersData.eventParticipants[teamNumber]?.lineup?.players?.forEach(player => {
            player.incidents.forEach(incident => {
                if (incident.incident.isHidden) return;
                if (incident.__typename.includes('SubstitutionIn')) {
                    const playerInId = incident.incident.playerId;
                    const playerOutId = incident.playerOutId;
                    substitutions.push({
                        playerIn: playersByIds[playerInId],
                        playerOut: playersByIds[playerOutId],
                        minute: incident.incident.minute
                    });
                }
            });
        });
        return substitutions;
    };

    const teamASubstitutions = getSubstitutions(0);
    const teamBSubstitutions = getSubstitutions(1);

    const rows = [];
    for (let i = 0; i < Math.max(teamASubstitutions.length, teamBSubstitutions.length); i++) {
        // Command A
        const playerInA = teamASubstitutions[i]?.playerIn;
        const playerOutA = teamASubstitutions[i]?.playerOut;
        const minuteA = teamASubstitutions[i]?.minute;

        // Command B
        const playerInB = teamBSubstitutions[i]?.playerIn;
        const playerOutB = teamBSubstitutions[i]?.playerOut;
        const minuteB = teamBSubstitutions[i]?.minute;

        rows.push((
            <div className="table__row" key={teamASubstitutions[i] || teamBSubstitutions[i]}>
                {teamASubstitutions[i] ? (
                    <div className="table__col table__col--grow">
                        <Substitution playerIn={playerInA} playerOut={playerOutA} minute={minuteA} />
                    </div>
                ) : (<div className="table__col table__col--grow"></div>)}
                {teamBSubstitutions[i] ? (
                    <div className="table__col table__col--grow">
                        <Substitution playerIn={playerInB} playerOut={playerOutB} minute={minuteB} reversed />
                    </div>
                ) : (<div className="table__col table__col--grow"></div>)}
            </div>
        ));
    }

    if (!playersData) return;
    if (!teamASubstitutions.length && !teamBSubstitutions.length) return;

    return (
        <div className="team-substitutions">
            <div className="table">
                <div className="table__row table__header">
                    <div className="table__col">
                        Замененные игроки
                    </div>
                </div>
                { rows }
            </div>
        </div>
    );
}

function Substitution ({ playerIn, playerOut, minute, reversed }) {

    const ratingColor = (rating) => {
        if (rating >= 7.5) return '#0aa00a';
        if (rating >= 7.0) return '#7dd83b';
        if (rating >= 6.5) return '#facf31';
        if (rating >= 6.0) return '#fdb119';
        return '#e53e19';
    }

    const playerInName = playerIn?.listName;
    const playerInRating = playerIn?.rating?.value;
    const playerOutName = playerOut?.listName;
    const playerInImagePath = playerIn.images[1]?.path || playerIn.images[0]?.path;

    return (
        <div className={`team-substitutions__substitution ${reversed ? 'team-substitutions__substitution--reversed' : ''}`}>
            {playerInImagePath && (<img 
                className="team-substitutions__player-image"
                src={`https://static.flashscore.com/res/image/data/${playerInImagePath}`} alt="" 
            />)}
            <div>
                <div className="team-substitutions__player-name">
                    {playerInName}
                    {playerInRating && (
                        <div 
                            className="team-substitutions__player-rating" 
                            style={{backgroundColor: ratingColor(playerInRating)}}
                        >
                            {playerInRating}
                        </div>
                    )}
                </div>
                <div className="team-substitutions__player-out">
                    <img src={SubstitutionIcon} alt="" />
                    <span>{playerOutName}</span>
                    <span>{minute}</span>
                </div>
            </div>
        </div>
    )
}